export const PAGE_PROPERTY_NAMES = {
  AB_STATUS: 'hs_ab_status',
  AB_TEST_ID: 'hs_ab_test_id',
  DYNAMIC_PAGE_DATA_SOURCE_TYPE: 'hs_dynamic_page_data_source_type',
  DYNAMIC_PAGE_DATA_SOURCE_ID: 'hs_dynamic_page_data_source_id',
  MAB_EXPERIMENT_ID: 'hs_mab_experiment_id',
  MAB_PAST_EXPERIMENT_IDS: 'hs_past_mab_experiment_ids',
  PASSWORD: 'hs_password',
  TEST_STATUS: 'hs_test_status',
  THEME_PATH: 'hs_theme_path',
  VARIATION: 'hs_variation',
  PERSONALIZATION_STRATEGY_ID: 'hs_personalization_strategy_id',
  PERSONALIZATION_VARIANT_STATUS: 'hs_personalization_variant_status',
  RESOLVED_STATE: 'hs_resolved_state'
};